import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

function BasicEventIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="layer1"
        transform="translate(0,8)">
        <g
          transform="translate(23.294782,-8.8009128)"
          id="g4659">
          <circle
            r="11.37975"
            cy="12.78124"
            cx="-11.27425"
            id="path4258-4"
            opacity="0.3"
          />
          <path
            id="path4258-98"
            opacity="0.8"
            d="m -11.275025,0.89010848 c -6.549905,0 -11.887309,5.34008642 -11.887309,11.88998952 0,6.549904 5.337404,11.889989 11.887309,11.889989 6.5499043,0 11.88998989,-5.340085 11.88998989,-11.889989 0,-6.5499031 -5.34008559,-11.88998952 -11.88998989,-11.88998952 z m 0,2.74652592 c 5.0655712,0 9.1434639,4.0778925 9.1434639,9.1434636 0,5.06557 -4.0778927,9.143464 -9.1434639,9.143464 -5.065571,0 -9.140782,-4.077894 -9.140782,-9.143464 0,-5.0655711 4.075211,-9.1434636 9.140782,-9.1434636 z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default BasicEventIcon;

